import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ElementRef,
  Input
} from '@angular/core';

// Servicios
import { DragulaService } from 'ng2-dragula';
// Components
import { SxBaseContainerDesigner } from '../designers/base/base-container-designer-component';
import { DesignAttributeType } from '../../types/designer-attribute-type';
import { IDesignerFactoryService } from '../../services/designer-factory-interface';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'sx-main-container',
  templateUrl: './main-container.component.html'
})
export class SxMainContainer extends SxBaseContainerDesigner
  implements OnInit, OnDestroy {
  @Output() clickSaveDesigner: EventEmitter<any> = new EventEmitter();
  @Output() clickCleanDesigner: EventEmitter<any> = new EventEmitter();
  @ViewChild('mainContainer', { read: ViewContainerRef })
  private mainContainer: ViewContainerRef;
  changeText: boolean = false;
  @Input() selectedPanel: string;
  @Input() isNonTransactional: boolean;

  constructor(
    dragulaService: DragulaService,
    designerFactoryService: IDesignerFactoryService,
    container: ElementRef,
    public ngxSmartModalService: NgxSmartModalService
  ) {
    super(dragulaService, designerFactoryService, 'SxPanel', container);
  }

  getElementModal(instance: any) {
    this.ngxSmartModalService.setModalData(instance, 'attributesModal');
    this.ngxSmartModalService.getModal('attributesModal').open();
  }

  toggleSave() {
    this.clickSaveDesigner.emit(null);
  }

  toggleClean() {
    this.clickCleanDesigner.emit(null);
  }

  loadDefaults(): void {
    super.loadDefaults();
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();
    info['title'] = this.controlContext.title;

    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();

    const titleAtt = new DesignAttributeType(
      this.controlContext,
      'string',
      'TITLE'
    );

    this.attributes.push(titleAtt);
  }

  ngOnInit(): void {
    this.placeHolderContainer = this.mainContainer;
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/main/main-container.component.ts